<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title class="error white--text">
        Sales Transactions
        <v-spacer></v-spacer>
        <v-btn
          v-if="sales.length"
          icon
          class="d-print-none"
          @click="PrintPage"
          small
          color="white"
        >
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <v-card-title>
            <!-- {{ TranInfo.FullName }} -->
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="fas fa-search"
              outlined
              dense
              label="Search"
              single-line
              hide-details
              class="d-print-none"
            ></v-text-field>
          </v-card-title>

          <v-data-table
            flat
            :headers="headers"
            :items="sales"
            :search="search"
            :item-class="FormatReturnFn"
          >
            <template v-slot:top>
              <v-toolbar flat color="grey lighten-4">
                <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                  >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                >

                <v-divider class="mx-4" inset vertical></v-divider>
                <!-- <div class="flex-grow-1"></div> -->
                <searchDate
                  :searching="searching"
                  :SearchFun="OnSearch"
                ></searchDate>
                <v-spacer></v-spacer>
                <div>
                  <cashDisplay
                    :isloading="isloading"
                    :Balance="TotalSale"
                  ></cashDisplay>
                </div>
              </v-toolbar>
            </template>

            <template v-slot:[`item.Details`]="{ item }">
              <!-- <p @dblclick="DetailsHandlar(item)">
                {{ item.Details | filterCode }}
              </p> -->
              <SalesDetails :item="item">
                {{ item.Details | filterCode }}</SalesDetails
              >
            </template>

            <template v-slot:[`item.Amount`]="{ item }">
              {{ item.Amount && item.Amount.toLocaleString() }}
              {{ item.AmountType && item.AmountType | MoneySigns }}
            </template>
            <template v-slot:[`item.print`]="{ item }">
              <base-row-layout>
                <!-- Sales Print and view items Icon -->
                <div>
                  <PrintView
                    :key="'print' + item._id"
                    :SaleOrder="item"
                  ></PrintView>
                </div>
                <div v-if="!ShowEditeItem(item.Details, item.Ref)">
                  <EditeSales
                    :OnFinish="() => OnSearch(fromDate, toDate)"
                    :key="'editSale' + item._id"
                    :SaleOrder="item"
                  />
                </div>
                <!-- Edite Date Icon -->
                <div>
                  <base-edite-date
                    :Info="item"
                    :BaseURL="SalesRepo"
                    :Disable="{ Details: true }"
                    :FinishedWithdrow="
                      () => {
                        OnSearch(fromDate, toDate);
                      }
                    "
                  ></base-edite-date>
                </div>
                <!-- Sales Delete Icon -->
                <div>
                  <BaseDelete
                    v-if="UsersToken.UserType === 'Admin'"
                    :OnFinish="
                      () => {
                        OnSearch(fromDate, toDate);
                      }
                    "
                    :DelQuery="{ ...item }"
                    :DelUrl="SalesRepo"
                  >
                    <template #title> DELETE SALE {{ item.Details }} </template>

                    <v-row>
                      <v-col>{{ item.date }}</v-col>
                      <v-col>{{ item.Name }}</v-col>
                      <v-col>{{ item.Details }}</v-col>
                      <v-col>{{
                        item.Amount && item.Amount.toLocaleString()
                      }}</v-col>
                    </v-row>
                    <!-- <p>{{ item }}</p> -->
                  </BaseDelete>
                </div>

                <!-- Return Option Icon -->
                <div v-if="!IsReturnItm(item.Ref)">
                  <returnOption :SaleOrder="item" />
                </div>
              </base-row-layout>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { EventBus } from "@/main";
import { mapGetters } from "vuex";
export default {
  components: {
    cashDisplay: () => import("@/components/util/displayCash"),
    searchDate: () => import("@/components/util/searchDate.vue"),
    PrintView: () =>
      import("@/components/Branches/Sales/Options/printSaleReport.vue"),
    SalesDetails: () =>
      import("@/components/Branches/Sales/Options/SalesDetails.vue"),
    returnOption: () =>
      import("@/components/Branches/Sales/Options/returnOption.vue"),
    EditeSales: () =>
      import("@/components/Branches/Sales/Options/EditeItems.vue"),
  },
  data() {
    return {
      SalesRepo: "/Reports/sales",
      searching: false,
      isloading: false,
      search: "",
      fromDate: "",
      toDate: "",
      sales: [],
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Client", value: "Name" },
        { text: "Sale", value: "Amount" },
        { text: "Order", value: "Details" },
        // { text: "User", value: "User" },
        { text: "View", class: "d-print-none text-center", value: "print" },
      ],
    };
  },
  computed: {
    ...mapGetters(["UsersToken"]),
    TotalSale() {
      if (!this.sales.length) return [];
      return [
        {
          Amount: this.sales.reduce((t, s) => (t += s.Amount), 0),
          AmountType: this.UsersToken && this.UsersToken.CashBase,
        },
      ];
    },
  },
  methods: {
    DetailsHandlar(item) {
      console.log(item);
    },
    IsReturnItm(Ref) {
      return Ref.match(new RegExp("^RET")) != null;
    },
    ShowEditeItem(str, Ref) {
      return str.toString().match("=>") != null || this.IsReturnItm(Ref);
    },
    FormatReturnFn({ Ref }) {
      // console.log();
      if (this.IsReturnItm(Ref)) return "error lighten-5";
      return "";
    },
    async PrintPage() {
      // console.log(this.UsersToken);
      //   this.itemPerPage = this.Transactions.length;
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      //   this.itemPerPage = 10;
    },
    OnSearch(from, to) {
      this.fromDate = from;
      this.toDate = to;

      this.sales = [];

      this.searching = true;
      this.isloading = true;

      this.GetReq()
        .then(result => {
          // console.log(result[0]);
          this.isloading = false;
          this.searching = false;
          this.sales = result.data;
        })
        .catch(() => {
          this.isloading = false;
          this.searching = false;
          // console.log(error);
        });
    },
    GetReq() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.SalesRepo,
        query: { from: this.fromDate, to: this.toDate },
      });
    },
    loadSales() {
      try {
        // this.$store
        //   .dispatch("GET_ONLY", this.SalesRepo)
        this.searching = true;
        this.isloading = true;
        this.GetReq()
          .then(value => {
            this.searching = false;
            this.isloading = false;
            this.sales = value.data;
          })
          .catch(err => {
            this.searching = false;
            this.isloading = false;
            console.log(err);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    const { date } = this.Current();
    this.fromDate = date;
    this.toDate = date;
    this.loadSales();
  },
};
</script>
